"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCalendar = void 0;
var string_formatters_1 = require("@newfront-insurance/string-formatters");
var react_1 = require("react");
function useCalendar(options) {
    var initialVisibleMonth = options.initialVisibleMonth, initialVisibleYear = options.initialVisibleYear;
    var _a = (0, react_1.useState)(initialVisibleYear), visibleYear = _a[0], setVisibleYear = _a[1];
    var _b = (0, react_1.useState)(initialVisibleMonth), visibleMonth = _b[0], setVisibleMonth = _b[1];
    var calendar = (0, string_formatters_1.createCalendar)({
        month: visibleMonth,
        year: visibleYear,
    });
    function increaseMonth() {
        var nextMonth = visibleMonth + 1;
        if (nextMonth > 12) {
            setVisibleMonth(1);
            setVisibleYear(visibleYear + 1);
        }
        else {
            setVisibleMonth(nextMonth);
        }
    }
    function decreaseMonth() {
        var prevMonth = visibleMonth - 1;
        if (prevMonth < 1) {
            setVisibleMonth(12);
            setVisibleYear(visibleYear - 1);
        }
        else {
            setVisibleMonth(prevMonth);
        }
    }
    return {
        increaseMonth: increaseMonth,
        decreaseMonth: decreaseMonth,
        calendar: calendar,
        year: visibleYear,
        month: visibleMonth,
        setYear: function (year) {
            setVisibleYear(year);
        },
        setMonth: function (month) {
            setVisibleMonth(month);
        },
    };
}
exports.useCalendar = useCalendar;
//# sourceMappingURL=calendar.js.map